import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHeaders } from "./baseQueries";

export const advertiseApi = createApi({
  reducerPath: "advertiseApi",
  baseQuery: baseQueryWithAuthHeaders,
  tagTypes: ["Advertise"],
  endpoints: (build) => ({
    getAllAdvertise: build.query({
      query: () => ({
        url: "/advertise",
        method: "GET",
      }),
      providesTags: ["Advertise"],
      transformResponse: (response) => response.data,
    }),
    getCities: build.query({
      query: () => ({
        url: "/advertise/cities",
        method: "GET",
      }),
      providesTags: ["Advertise"],
      transformResponse: (response) => response.data,
    }),
    getAllAdvertiseByCity: build.query({
      query: ({ city }) => ({
        url: `/advertise/filter`,
        method: "GET",
        params: {
          city,
        },
      }),
      providesTags: ["Advertise"],
      transformResponse: (response) => response.data,
    }),
    getFilterAdvertise: build.query({
      query: ({
        city,
        minArea,
        maxArea,
        minUsableArea,
        maxUsableArea,
        rooms,
        minPrice,
        maxPrice,
        minConstructionYear,
        maxConstructionYear,
        advertise_type,
        category,
        sub_category,
        furnishing,
        searchMode,
        name,
        email,
        notes,
      }) => ({
        url: `/advertise/filter`,
        method: "GET",
        params: {
          city,
          minArea,
          maxArea,
          minUsableArea,
          maxUsableArea,
          rooms,
          minPrice,
          maxPrice,
          minConstructionYear,
          maxConstructionYear,
          advertise_type,
          category,
          sub_category,
          furnishing,
          searchMode,
          name,
          email,
          notes,
        },
      }),
      providesTags: ["Advertise"],
      transformResponse: (response) => response.data,
    }),
    addAdvertise: build.mutation({
      query: (data) => ({
        url: `/advertise/add`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Advertise"],
    }),
    submitValuationRequest: build.mutation({
      query: (data) => ({
        url: `/advertise/valuation-request`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetAllAdvertiseQuery,
  useGetCitiesQuery,
  useAddAdvertiseMutation,
  useGetAllAdvertiseByCityQuery,
  useGetFilterAdvertiseQuery,
  useSubmitValuationRequestMutation,
} = advertiseApi;
